<ion-toolbar class="main-header-toolbar">
    <app-student-header></app-student-header>
</ion-toolbar>

<ion-content [fullscreen]="true" class="content">
    <!--refresher-->
    <ion-refresher class="ion-hide-sm-up" slot="fixed" [pullFactor]="0.5" [pullMin]="100"
                   (ionRefresh)="refresh($event)">
        <ion-refresher-content></ion-refresher-content>

    </ion-refresher>
    <!--refresher end-->

    <ion-grid fixed class="page-grid no-margin-top student-grid student-page">

        <app-semi-header [title]=" ('lessonSchedule'|transloco) "></app-semi-header>

        <ion-row *transloco="let t; read: 'profileBarComp'">
            <ion-col size="12" class="ion-no-margin ion-no-padding">
                <app-tabs [styleGroup]="true" [studentStyle]="true" [showSchedule]="false">

                    <app-tab [tabTitle]="t('currentCourses')" [svg]="true" [active]="activeCurrentGroupsTabs">
                        <ion-row class="study-content ion-no-padding"
                                 *ngIf="this.currentGroups && this.currentGroups?.length">

                            <ion-col size="12" class="ion-no-padding ion-no-margin white-col top-block">

                                <div class="calendar-wrapper">

                                    <app-calendar [schedule]="this.currentSchedule"
                                                  [holidays]="this.currentHolidays"></app-calendar>


                                </div>

                                <div class="lesson-wrapper" *ngIf="this.currentLessons">

                                    <app-next-lesson *ngFor="let lesson of this.currentLessons"
                                                     [data]="lesson.data"
                                                     [title]="lesson.title"
                                                     [class]="lesson?.color === '80b0b2' ? 'light-blue-bg' : lesson?.color === 'EBC700' ? 'yellow-bg': 'green-bg'"
                                                     [isCurrent]='true'
                                                     [isSchedule]="true" [practice]="true"></app-next-lesson>

                                </div>
                            </ion-col>


                            <ion-col size="12" class="ion-no-padding ion-no-margin btn-wrapper">
                                <button type="button" class="btn dark-btn ion-hide-md-down"
                                        (click)="openModal('practicing',this.currentGroups )"> {{ t('practising') }}
                                </button>


                                <button type="button" class="content-btn btn  ion-hide-md-up"
                                        (click)="openModal('practicing',this.currentGroups )">
                                    <div class="content-inner">
                                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_5809_5758)">
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                      d="M0 29.1902V3.48445C0 2.25588 0.782857 1.14731 1.98 0.858734C7.42286 -0.444123 13.8229 -0.0641226 18.3429 2.12445C19.38 2.62731 20.6143 2.62731 21.6514 2.12445C26.1743 -0.0641226 32.5743 -0.444123 38.0171 0.858734C39.2143 1.14445 39.9971 2.25302 39.9971 3.48159V21.6216C39.54 20.8787 38.9971 20.173 38.3429 19.5216C35.7686 16.9445 32.3514 15.9902 29.0171 15.9902C25.6829 15.9902 22.2657 16.9445 19.6886 19.5216C17.1114 22.0987 16.1571 25.5159 16.1571 28.8502C16.1571 29.5816 16.2029 30.3187 16.3029 31.0502C11.9914 29.6044 6.58857 29.4902 1.90286 30.6273C0.957143 30.8559 0 30.1702 0 29.1902Z"
                                                      fill="#D7F3C2"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                      d="M18.3398 2.22119V2.12405C19.377 2.62691 20.617 2.62691 21.6541 2.12405L21.8998 2.00977C21.9066 2.08005 21.9104 2.15059 21.9113 2.22119V17.7983C20.4892 18.6434 19.27 19.7904 18.3398 21.1583V2.22119Z"
                                                      fill="#83B25F"/>
                                                <path
                                                    d="M29.0198 35.9927C33.5912 35.9927 36.1627 33.4213 36.1627 28.8499C36.1627 24.2785 33.5912 21.707 29.0198 21.707C24.4484 21.707 21.877 24.2785 21.877 28.8499C21.877 33.4213 24.4484 35.9927 29.0198 35.9927Z"
                                                    fill="#D7F3C2"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                      d="M24.0172 28.8502C24.0172 26.9587 24.5429 25.7816 25.2457 25.0787C25.9514 24.373 27.1286 23.8502 29.0172 23.8502C30.9114 23.8502 32.0857 24.373 32.7886 25.0787C33.4943 25.7816 34.02 26.9587 34.02 28.8502C34.02 30.7416 33.4943 31.9159 32.7914 32.6216C32.0857 33.3273 30.9114 33.8502 29.02 33.8502C27.1286 33.8502 25.9514 33.3273 25.2486 32.6216C24.5429 31.9159 24.0172 30.7416 24.0172 28.8502ZM29.0172 19.5645C26.34 19.5645 23.9429 20.3245 22.2172 22.0502C20.4914 23.773 19.7314 26.1702 19.7314 28.8502C19.7314 31.5302 20.4914 33.9273 22.2172 35.6502C23.9429 37.3759 26.34 38.1359 29.0172 38.1359C30.8914 38.1359 32.6286 37.7645 34.0914 36.953L36.2 39.0616C36.6062 39.4401 37.1435 39.6462 37.6987 39.6364C38.2538 39.6266 38.7835 39.4017 39.1761 39.0091C39.5687 38.6165 39.7936 38.0868 39.8034 37.5317C39.8132 36.9765 39.6071 36.4392 39.2286 36.033L37.1229 33.9216C37.9343 32.4587 38.3057 30.7216 38.3057 28.8502C38.3057 26.1702 37.5457 23.773 35.82 22.0502C34.0972 20.3245 31.6972 19.5645 29.0172 19.5645Z"
                                                      fill="#83B25F"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_5809_5758">
                                                    <rect width="40" height="40" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        {{ t('practising') }}
                                    </div>
                                    <div class="arrow">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                  d="M8.51192 19.5694C8.19743 19.2999 8.161 18.8264 8.43057 18.5119L14.0122 12L8.43057 5.4881C8.161 5.1736 8.19743 4.70013 8.51192 4.43056C8.82641 4.16099 9.29989 4.19741 9.56946 4.51191L15.5695 11.5119C15.8102 11.7928 15.8102 12.2072 15.5695 12.4881L9.56946 19.4881C9.29989 19.8026 8.82641 19.839 8.51192 19.5694Z"
                                                  fill="#3F403F"/>
                                        </svg>

                                    </div>

                                </button>

                            </ion-col>

                            <div class="title">
                                {{ t('aboutGroup') }}
                            </div>


                            <ion-col size="12" class="ion-no-padding ion-no-margin about-group white-col"
                                     *transloco="let t; read: 'profileBarComp'">

                                <div
                                    class="group group-{{group?.color === '80b0b2' ? 'light-blue-bg' : group?.color === 'EBC700' ? 'yellow-bg': 'green-bg'}}"
                                    *ngFor="let group of this.currentGroups">

<!--                                    <div class="title-group"> {{ group.title |transloco }}</div>-->
                                    <div class="title-group"> {{ group.title }}</div>

                                    <div class="content-accordion list-info" slot="content">
                                        <ion-list>
                                            <ion-item>
                                                <ion-label>
                                                    <div class="info">
                                                        <div class="title">{{ t('level') }}</div>
                                                        <div class="sub-title ion-align-items-start">
                                                            <img src="/assets/images/icons/levels.svg" alt="levels">
                                                            {{ group.englishLevel }}
                                                        </div>
                                                    </div>
                                                </ion-label>
                                            </ion-item>

                                            <ion-item>
                                                <ion-label>
                                                    <div class="info">
                                                        <div class="title">{{ t('studyMaterial') }}</div>
                                                        <div class="sub-title ion-align-items-start">
                                                            <img src="/assets/images/icons/books.svg" alt="books">
                                                            {{ group.educationMaterialTitle }}
                                                        </div>
                                                    </div>
                                                </ion-label>
                                            </ion-item>
                                            <ion-item>
                                                <ion-label>
                                                    <div class="info">
                                                        <div class="title">{{ t('schedule') }}</div>
                                                        <div class="sub-title ion-align-items-start">
                                                            <img src="/assets/images/icons/schedule.svg" alt="calendar">
                                                            {{ group.scheduleText }}
                                                        </div>
                                                    </div>
                                                </ion-label>
                                            </ion-item>
                                            <ion-item>
                                                <ion-label>
                                                    <div class="info">
                                                        <div class="title">{{ t('holidays') }}</div>
                                                        <div class="sub-title ion-align-items-start">
                                                            <img src="/assets/images/icons/holidays.svg" alt="holidays">
                                                            {{ group.holidays }}
                                                        </div>
                                                    </div>
                                                </ion-label>
                                            </ion-item>
                                            <ion-item>
                                                <ion-label>
                                                    <div class="info">
                                                        <div class="title">{{ t('teacher') }}</div>
                                                        <div class="sub-title ion-align-items-start">
                                                            <img src="/assets/images/icons/teacher.svg" alt="teacher">
                                                            {{ group.teacherName }}
                                                        </div>
                                                    </div>
                                                </ion-label>
                                            </ion-item>

                                            <ion-item>
                                                <ion-label>
                                                    <div class="info">
                                                        <div class="title">{{ t('address') }}</div>
                                                        <div class="sub-title  ion-align-items-start">
                                                            <img src="/assets/images/icons/location.svg" alt="location">
                                                            {{ group.address }}
                                                        </div>
                                                    </div>
                                                </ion-label>
                                            </ion-item>
                                        </ion-list>
                                    </div>
                                </div>

                            </ion-col>


                        </ion-row>

                        <ion-row class="study-content ion-no-padding"
                                 *ngIf="(this.currentGroups && this.currentGroups?.length==0)">

                            <ion-col size="12" class="ion-no-padding ion-no-margin white-col top-block">
                                <app-dummy [type]="'schedule'" [isImageSmall]="true"></app-dummy>
<!--                                <img src="assets/images/dummies/no_schedule.png" alt="no schedule">-->

                            </ion-col>



                        </ion-row>
                    </app-tab>

                    <app-tab [tabTitle]="t('futureCourses')" [svg]="true" [active]="activeFuturesGroupsTabs">
                        <ion-row class="study-content ion-no-padding"
                                 *ngIf="this.futureGroups && this.futureGroups.length">

                            <ion-col size="12" class="ion-no-padding ion-no-margin white-col top-block">

                                <div class="calendar-wrapper">

                                    <app-calendar [schedule]="this.futureSchedule"
                                                  [holidays]="this.futureHolidays"></app-calendar>


                                </div>

                                <div class="lesson-wrapper" *ngIf="this.futureLessons">

                                    <app-next-lesson *ngFor="let lesson of this.futureLessons"
                                                     [data]="lesson.data"
                                                     [title]="lesson.title"
                                                     [class]="lesson?.color === '80b0b2' ? 'light-blue-bg' : lesson?.color === 'EBC700' ? 'yellow-bg': 'green-bg'"
                                                     [isCurrent]='true'
                                                     [isSchedule]="true" [practice]="true"></app-next-lesson>

                                </div>
                            </ion-col>


                            <ion-col size="12" class="ion-no-padding ion-no-margin btn-wrapper">
                                <button type="button" class="btn dark-btn ion-hide-md-down"
                                        (click)="openModal('practicing',this.futureGroups )">
                                    {{ t('practising') }}

                                </button>

                                <button type="button" class="content-btn btn  ion-hide-md-up"
                                        (click)="openModal('practicing', this.futureGroups)">
                                    <div class="content-inner">
                                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_5809_5758)">
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                      d="M0 29.1902V3.48445C0 2.25588 0.782857 1.14731 1.98 0.858734C7.42286 -0.444123 13.8229 -0.0641226 18.3429 2.12445C19.38 2.62731 20.6143 2.62731 21.6514 2.12445C26.1743 -0.0641226 32.5743 -0.444123 38.0171 0.858734C39.2143 1.14445 39.9971 2.25302 39.9971 3.48159V21.6216C39.54 20.8787 38.9971 20.173 38.3429 19.5216C35.7686 16.9445 32.3514 15.9902 29.0171 15.9902C25.6829 15.9902 22.2657 16.9445 19.6886 19.5216C17.1114 22.0987 16.1571 25.5159 16.1571 28.8502C16.1571 29.5816 16.2029 30.3187 16.3029 31.0502C11.9914 29.6044 6.58857 29.4902 1.90286 30.6273C0.957143 30.8559 0 30.1702 0 29.1902Z"
                                                      fill="#D7F3C2"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                      d="M18.3398 2.22119V2.12405C19.377 2.62691 20.617 2.62691 21.6541 2.12405L21.8998 2.00977C21.9066 2.08005 21.9104 2.15059 21.9113 2.22119V17.7983C20.4892 18.6434 19.27 19.7904 18.3398 21.1583V2.22119Z"
                                                      fill="#83B25F"/>
                                                <path
                                                    d="M29.0198 35.9927C33.5912 35.9927 36.1627 33.4213 36.1627 28.8499C36.1627 24.2785 33.5912 21.707 29.0198 21.707C24.4484 21.707 21.877 24.2785 21.877 28.8499C21.877 33.4213 24.4484 35.9927 29.0198 35.9927Z"
                                                    fill="#D7F3C2"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                      d="M24.0172 28.8502C24.0172 26.9587 24.5429 25.7816 25.2457 25.0787C25.9514 24.373 27.1286 23.8502 29.0172 23.8502C30.9114 23.8502 32.0857 24.373 32.7886 25.0787C33.4943 25.7816 34.02 26.9587 34.02 28.8502C34.02 30.7416 33.4943 31.9159 32.7914 32.6216C32.0857 33.3273 30.9114 33.8502 29.02 33.8502C27.1286 33.8502 25.9514 33.3273 25.2486 32.6216C24.5429 31.9159 24.0172 30.7416 24.0172 28.8502ZM29.0172 19.5645C26.34 19.5645 23.9429 20.3245 22.2172 22.0502C20.4914 23.773 19.7314 26.1702 19.7314 28.8502C19.7314 31.5302 20.4914 33.9273 22.2172 35.6502C23.9429 37.3759 26.34 38.1359 29.0172 38.1359C30.8914 38.1359 32.6286 37.7645 34.0914 36.953L36.2 39.0616C36.6062 39.4401 37.1435 39.6462 37.6987 39.6364C38.2538 39.6266 38.7835 39.4017 39.1761 39.0091C39.5687 38.6165 39.7936 38.0868 39.8034 37.5317C39.8132 36.9765 39.6071 36.4392 39.2286 36.033L37.1229 33.9216C37.9343 32.4587 38.3057 30.7216 38.3057 28.8502C38.3057 26.1702 37.5457 23.773 35.82 22.0502C34.0972 20.3245 31.6972 19.5645 29.0172 19.5645Z"
                                                      fill="#83B25F"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_5809_5758">
                                                    <rect width="40" height="40" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>


                                        {{ t('practising') }}
                                    </div>
                                    <div class="arrow">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                  d="M8.51192 19.5694C8.19743 19.2999 8.161 18.8264 8.43057 18.5119L14.0122 12L8.43057 5.4881C8.161 5.1736 8.19743 4.70013 8.51192 4.43056C8.82641 4.16099 9.29989 4.19741 9.56946 4.51191L15.5695 11.5119C15.8102 11.7928 15.8102 12.2072 15.5695 12.4881L9.56946 19.4881C9.29989 19.8026 8.82641 19.839 8.51192 19.5694Z"
                                                  fill="#3F403F"/>
                                        </svg>

                                    </div>

                                </button>

                            </ion-col>

                            <div class="title">
                                {{ t('aboutGroup') }}
                            </div>


                            <ion-col size="12" class="ion-no-padding ion-no-margin about-group white-col"
                                     *transloco="let t; read: 'profileBarComp'">

                                <div
                                    class="group group-{{group?.color === '80b0b2' ? 'light-blue-bg' : group?.color === 'EBC700' ? 'yellow-bg': 'green-bg'}}"
                                    *ngFor="let group of this.futureGroups">

                                    <div class="title-group"> {{ group.title }}</div>

                                    <div class="content-accordion list-info" slot="content">
                                        <ion-list>
                                            <ion-item>
                                                <ion-label>
                                                    <div class="info">
                                                        <div class="title">{{ t('level') }}</div>
                                                        <div class="sub-title ion-align-items-start">
                                                            <img src="/assets/images/icons/levels.svg" alt="levels">
                                                            {{ group.englishLevel }}
                                                        </div>
                                                    </div>
                                                </ion-label>
                                            </ion-item>
                                            <ion-item>
                                                <ion-label>
                                                    <div class="info">
                                                        <div class="title">{{ t('studyMaterial') }}</div>
                                                        <div class="sub-title ion-align-items-start">
                                                            <img src="/assets/images/icons/books.svg" alt="books">
                                                            {{ group.educationMaterialTitle }}
                                                        </div>
                                                    </div>
                                                </ion-label>
                                            </ion-item>
                                            <ion-item>
                                                <ion-label>
                                                    <div class="info">
                                                        <div class="title">{{ t('schedule') }}</div>
                                                        <div class="sub-title ion-align-items-start">
                                                            <img src="/assets/images/icons/schedule.svg" alt="calendar">
                                                            {{ group.scheduleText }}
                                                        </div>
                                                    </div>
                                                </ion-label>
                                            </ion-item>
                                            <ion-item>
                                                <ion-label>
                                                    <div class="info">
                                                        <div class="title">{{ t('holidays') }}</div>
                                                        <div class="sub-title ion-align-items-start">
                                                            <img src="/assets/images/icons/holidays.svg" alt="holidays">
                                                            {{ group.holidays }}
                                                        </div>
                                                    </div>
                                                </ion-label>
                                            </ion-item>
                                            <ion-item>
                                                <ion-label>
                                                    <div class="info">
                                                        <div class="title">{{ t('teacher') }}</div>
                                                        <div class="sub-title ion-align-items-start">
                                                            <img src="/assets/images/icons/teacher.svg" alt="teacher">
                                                            {{ group.teacherName }}
                                                        </div>
                                                    </div>
                                                </ion-label>
                                            </ion-item>

                                            <ion-item>
                                                <ion-label>
                                                    <div class="info">
                                                        <div class="title">{{ t('address') }}</div>
                                                        <div class="sub-title  ion-align-items-start">
                                                            <img src="/assets/images/icons/location.svg" alt="location">
                                                            {{ group.address }}
                                                        </div>
                                                    </div>
                                                </ion-label>
                                            </ion-item>
                                        </ion-list>
                                    </div>
                                </div>

                            </ion-col>
                        </ion-row>

                        <ion-row class="study-content ion-no-padding"
                                 *ngIf="(this.futureGroups && this.futureGroups?.length==0)">

                            <ion-col size="12" class="ion-no-padding ion-no-margin white-col top-block">

                                <app-dummy [type]="'schedule'" [isImageSmall]="true"></app-dummy>
<!--                                <img src="assets/images/dummies/no_schedule.png" alt="no schedule">-->

                            </ion-col>

                        </ion-row>


                        <ion-row *ngIf="!hasFutureGroup" class="study-content ion-no-padding">
                            <ion-col size="12" class="ion-no-padding ion-no-margin white-col">
                                <app-no-course-notice [futureGroup]="true"
                                                      [class]="'border-grey'"></app-no-course-notice>

                            </ion-col>
                        </ion-row>
                    </app-tab>

                </app-tabs>


                <app-banners [banners]=""></app-banners>

            </ion-col>


        </ion-row>


    </ion-grid>

    <app-footer></app-footer>

</ion-content>

<app-chats></app-chats>
